'use client';

import { TDraftBasicInfo } from '@/types';
import { useEffect, useState } from 'react';

const defaultData = {
  title: '',
  description: '',
};

export const useInput = (initialData?: TDraftBasicInfo | undefined) => {
  const [input, setInput] = useState(() => initialData ?? defaultData);

  useEffect(() => {
    if (initialData) setInput(initialData);
  }, [initialData]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setInput((prevValue) => ({ ...prevValue, [e.target.name]: e.target.value }));
  };

  return { input, handleChange };
};
